<template>
  <div v-if="link" class="service-providers-cta">
    <a
      :aria-label="label"
      :gtm-service-provider="provider"
      :href="link"
      class="button button--xl button--info"
      rel="external"
      target="_blank"
    >
      <span> Visit Website </span>
      <i class="icon">
        <Icon name="fa6-solid:arrow-up-right-from-square" />
      </i>
    </a>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  link: string
  linkLabel?: string
  provider: string
}>()
const { label } = useServiceProvider(props)
</script>

<style lang="less" scoped>
.service-providers-cta {
  margin: @gutter-xl 0;
}
</style>
